import { apiClient } from "./apiClient";
import { endpoints } from "./endpoints";
import type { ApiRecord } from "@/types/api";

export interface InstrumentSearchParams {
  tradingSymbol?: string;
  exchangeCode?: string;
  instrumentToken?: string;
}

/**
 * `search` wraps `GET /api/v1/market-data/instruments` - all filters
 * optional, genuinely zero-argument capable. `getMetadata` wraps Backend
 * v2.1's (Sprint 4.4) `GET /market-data/instrument`, a genuinely new
 * single-instrument-by-token capability (`InstrumentMetadataDto`) that
 * did not exist before - `provider`/`currency` are honestly `null` when
 * the backend has no such field for the instrument (TD-101).
 */
export const instrumentSearchService = {
  async search(params: InstrumentSearchParams = {}): Promise<ApiRecord[]> {
    const response = await apiClient.get<ApiRecord[]>(endpoints.marketData.instruments, {
      params: {
        trading_symbol: params.tradingSymbol,
        exchange_code: params.exchangeCode,
        instrument_token: params.instrumentToken,
      },
    });
    return response.data;
  },
  async getMetadata(instrumentToken: string): Promise<ApiRecord> {
    const response = await apiClient.get<ApiRecord>(endpoints.marketData.instrument, {
      params: { instrument_token: instrumentToken },
    });
    return response.data;
  },
};
